module.exports = __webpack_public_path__ + "static/little-devils-1-2-d492197b898adeeebd34c5393dd740b9.pdf";